export enum RoutesEnum {
  Login = 'login',
  Dashboard = 'dashboard',
  Revenue = 'revenue',
  CashAndCreditControl = 'cash-and-credit-control',
  TeamPerformance = 'team-performance',
  Clients = 'clients',
  Placements = 'placements',
  Timesheets = 'timesheets',
  BalanceSheetItemName = 'balance-sheet-item-name',
  Sales = 'sales',
  Purchases = 'purchases',
  Hr = 'hr',
  Inventory = 'inventory',
  Reports = 'reports',
  Settings = 'settings',
  Profile = 'profile',
}
